var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.027 8.359l6.032 5.734L17.82 2.31 16.16.756 6.942 10.845 2.55 6.678 1.027 8.359z",
    fill: "#001428"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxOSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMDI3MzQgOC4zNTg5OEw3LjA1OTIgMTQuMDkyNkwxNy44MjA1IDIuMzExMkwxNi4xNTg2IDAuNzU2MzMzTDYuOTQyMiAxMC44NDQ2TDIuNTUwNDQgNi42NzgwMkwxLjAyNzM0IDguMzU4OThaIiBmaWxsPSIjMDAxNDI4Ii8+Cjwvc3ZnPgo=";
export { SvgTick as ReactComponent };